// src/components/AuctionGrid.js
import React, { useEffect, useState } from "react";
import AuctionItem from "./AuctionItem";
import "../styles/product.css";
import { useNavigate } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../utils/firebaseconfig";

function AuctionGrid({ filter, category }) {
  const [auctions, setAuctions] = useState([]);
  const [filteredAuctions, setFilteredAuctions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAuctions = async () => {
      try {
        const snapshot = await getDocs(collection(db, "Auction"));
        const auctionData = [];
        snapshot.forEach((docSnap) => {
          auctionData.push({ id: docSnap.id, ...docSnap.data(), isAuction: true });
        });
        setAuctions(auctionData);
      } catch (error) {
        console.error("Error fetching auctions:", error);
      }
    };
    fetchAuctions();
  }, []);

  useEffect(() => {
    let result = [...auctions];

    // Apply category filter
    if (category) {
      result = result.filter(auction => 
        auction.category && auction.category.toLowerCase() === category.toLowerCase()
      );
    }

    // Apply sorting filter
    if (filter) {
      switch (filter) {
        case "price-low-high":
          result.sort((a, b) => (a.currentBid || 0) - (b.currentBid || 0));
          break;
        case "price-high-low":
          result.sort((a, b) => (b.currentBid || 0) - (a.currentBid || 0));
          break;
        case "alphabetic-asc":
          result.sort((a, b) => (a.title || "").localeCompare(b.title || ""));
          break;
        case "alphabetic-desc":
          result.sort((a, b) => (b.title || "").localeCompare(a.title || ""));
          break;
        default:
          break;
      }
    }

    setFilteredAuctions(result);
  }, [auctions, filter, category]);

  const handleAuctionClick = (auction) => {
    navigate(`/auction/${auction.id}`, { state: { auction } });
  };

  return (
    <div className="product-grid">
      {filteredAuctions.length > 0 ? (
        filteredAuctions.map((auction) => (
          <AuctionItem 
            key={auction.id} 
            {...auction} 
            onClick={() => handleAuctionClick(auction)}
          />
        ))
      ) : (
        <p className="no-items-message">
          {category 
            ? `No auctions available in the ${category} category` 
            : "No auctions available..."}
        </p>
      )}
    </div>
  );
}

export default AuctionGrid;
